














import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import NewsListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/NewsModels/NewsListResponse";

@Component
export default class PageNewsComponent extends Vue {
  newsResponse: WsResponseModel<NewsListResponse> = null;


  mounted() {
          this.$meta.setTitle('Новости');
    this.$api.NewsService.GetListEvent.once(this.onGetList.bind(this));
    this.$api.NewsService.GetList({});
  }
  onGetList(response: WsResponseModel<NewsListResponse>) {
    this.newsResponse = response;
  }
}
